import React from 'react'
import createReactClass from 'create-react-class'
import Select from '../select-dropdown'
import ConfirmationPanel from '../confirmation-panel'
import './monitoring-panel.scss'
import {filter, propEq} from 'ramda'
import ErrorBlock from '../../elements/error-block'

export default createReactClass({
  changePortfolio (val) {
    let id = this.getSelectedPortfolio('portfolioId', val, 'portfolioId')
    this.props.changePortfolio(id)
  },

  onSelect () {
    this.props.onMonitoringResultPageChange(1)
    this.props.searchCompanies(1, this.props.pageSize)
  },

  componentDidMount () {
    if (this.props.portfolios.length === 0) {
      this.props.getPortfolios()
    }
  },

  getCountries () {
    return this.props.countryList.map((country, index) => {
      return <div key={index}>{country.name} ({country.value})</div>
    })
  },

  deletePortfolio () {
    this.props.deletePortfolio()
  },

  createPortfolio (name) {
    this.props.createPortfolio(name)
  },

  getSelectedPortfolio (prop, val, key) {
    let items = filter(propEq(prop, val), this.props.portfolios)
    return items.length > 0 ? items[0][key] : 0
  },

  render () {
    return (
      <div className="monitoring-panel">
        {this.props.portfoliosLoader
          ? <div className='loader-ctr'><span className="loading"></span></div>
          : <div>{this.props.portfoliosError
            ? <ErrorBlock {...this.props.portfoliosError}/>
            : <div>
              {this.props.portfolios.length > 0
                ? <div>
                  <Select selected={this.props.selectedPortfolio}
                    onChange={this.changePortfolio} data={this.props.portfolios}/>
                  <button className='cs-secondary-button' onClick={this.onSelect}>Select</button>
                  <ConfirmationPanel onConfirm={this.deletePortfolio} isSuccess={this.props.isPortfolioDeleted}
                    isDisabled={this.getSelectedPortfolio('portfolioId', this.props.selectedPortfolio, 'isDefault')}
                    error={this.props.modalError} onModalClose={this.props.resetError}/>
                </div>
                : <div>There are no portfolios</div>
              }
            </div>
          }
          </div>
        }
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/monitoring-page/monitoring-form-panel.js